<template>
  <el-dialog title="代课详情" :visible.sync="dialogVisible" width="650px" class="teach-list">
    <el-tabs value="base">
      <el-tab-pane label="代课" name="base">
        <ul class="supply-list">
          <li>
            <div class="title">请假日期</div>
            <div class="content">{{defData.supply_start_time}} - {{defData.supply_end_time}}</div>
          </li>
          <li>
            <div class="title">代课类型</div>
            <div class="content">{{defData.supply_type_label}}</div>
          </li>
          <li>
            <div class="title">班级详情</div>
            <div class="content class-info">
              <span>{{defData.org_full_name}}</span>
              <span>{{defData.specialized_subject_full_name}}</span>
              <span>{{defData.class_name}}</span>
            </div>
          </li>
          <li>
            <div class="title">请假老师</div>
            <div class="content">{{defData.original_teacher_name}}</div>
          </li>
          <li>
            <div class="title">代课老师</div>
            <div class="content">{{defData.new_teacher_name}}</div>
          </li>
          <li>
            <div class="title">课时数</div>
            <div class="content">{{defData.supply_class_count}}</div>
          </li>
          <li>
            <div class="title">请假原因</div>
            <div class="content">{{defData.supply_reason}}</div>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="附件内容" name="file" v-if="defData.attach">
        <img :src="`${baseUrl}/${defData.attach}`" width="400px" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import { Dialog, Tabs, TabPane } from 'element-ui';

export default {
  name: 'TeachList',
  components: {
    ElDialog: Dialog,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  props: {
    defData: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      baseUrl: ''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 获取多媒体信息地址
      this.$store.dispatch('app/getOssUrl').then(url => {
        this.baseUrl = url;
      });
    },
    openDg() {
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="less">
.teach-list {
  .el-dialog__body {
    padding: 0 20px;
  }
  .supply-list {
    padding: 0;
    li {
      list-style: none;
      margin-bottom: 30px;
      .title {
        display: inline-block;
        font-weight: 700;
        width: 100px;
      }
      .content {
        display: inline-block;
      }
      .class-info {
        >span {
          display: inline-block;
          border: 1px solid @main-blue;
          border-radius: 3px;
          padding: 8px 15px;
          margin-right: 10px;
          margin-bottom: 2px;
        }
      }
    }
  }
}
</style>
